import './FeedTile.css'
import { routes } from '@/utilities/routes'
import type { FeedListItem } from 'aevocam-rest-api-spec'
import { FEED_CDN } from '@/utilities/envVariables'
import { Link } from 'react-router-dom'
import { Icon } from '@/components/graphics/Icon'
import { IconButton } from '@/components/action/IconButton'
import { Tooltip } from '@/components/action/Tooltip'
import { cn } from '@/utilities/misc'

//--------------------------------------------------------------------------------
export type FeedTileProps = {
  row: FeedListItem
  tenantId: string
}

export function FeedTile({ row, tenantId }: FeedTileProps) {
  const feedId = row.feed.id!
  const viewHref = routes.feedView(tenantId, feedId.toString())
  const editHref = routes.feedEdit(tenantId, feedId.toString())
  return (
    <div className={cn(
      'FeedTile',
      row.feed.disabled && 'Disabled',
    )}>
      <Link className='ThumbLink' to={viewHref}>
        <div className='Thumb'>
          {row.lastPhoto && row.token ? (
            <img
              src={feedThumbnailUrl(FEED_CDN, tenantId, feedId, row.lastPhoto.s, row.token)}
              alt=''
              loading='lazy'
            />
          ) : (
            <div className='Placeholder' aria-hidden>
              <Icon icon='camera' />
            </div>
          )}
        </div>
      </Link>
      <div className='Name'>
        <IconButton
          icon='pencil'
          tooltip='Edit'
          href={editHref}
          aria-label='Edit feed'
        />
        <Link className='NameText' to={viewHref}>
          <Tooltip placement='top'>
            {row.feed.name}
            {row.feed.disabled && <div>(Disabled)</div>}
          </Tooltip>
          {row.feed.name}
        </Link>
      </div>
    </div>
  )
}

//--------------------------------------------------------------------------------
function feedThumbnailUrl(
  cdnUrl: string,
  tenantId: string,
  feedId: number,
  photoSeq: number,
  token: string
): string {
  return `${cdnUrl}/${tenantId}/f/${feedId}/photo/${photoSeq}?tk=${encodeURIComponent(token)}`
}
